import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => {
  return {
    container: {
      maxWidth: '100%',

      '& input': {
        fontSize: theme.typography.appFontSize,
      },
    },
    tooltipSize: {
      fontSize: theme.typography.pxToRem(14),
      marginLeft: '0.313rem',
    },
    textAreaStyles: {
      '& textarea': {
        maxHeight: '250px',
      },
    },
  };
});

export default useStyles;
